import * as tslib_1 from "tslib";
import React, { Component } from 'react';
import styled from 'styled-components';
import { Form, Input, Select, Icon, Tooltip } from 'antd';
const Root = styled.div ``;
const FORM_ITEM_LAYOUT = {
    labelCol: { span: 6 },
    wrapperCol: { span: 15 },
};
class AddMenuModal extends Component {
    onModalOk() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { form: { validateFields }, } = this.props;
            const values = yield new Promise((resolve, reject) => {
                validateFields((errs, values) => {
                    if (errs)
                        return reject(errs);
                    resolve(values);
                });
            });
            return values;
        });
    }
    render() {
        const { className, style, form, initialValue, isEditMode } = this.props;
        const { getFieldDecorator } = form;
        return (<Root className={className} style={style}>
        <Form>
          <Form.Item label="parentId" {...FORM_ITEM_LAYOUT}>
            {getFieldDecorator('parentId', {
            initialValue: isEditMode
                ? initialValue.parentId
                : initialValue.id,
            rules: [{ required: true }],
        })(<Input disabled/>)}
          </Form.Item>
          <Form.Item label="菜单类型" {...FORM_ITEM_LAYOUT}>
            {getFieldDecorator('type', {
            initialValue: isEditMode
                ? initialValue.type
                : initialValue.type + 1,
            rules: [{ required: true }],
        })(<Select disabled>
                <Select.Option value={0}>一级菜单</Select.Option>
                <Select.Option value={1}>二级菜单</Select.Option>
                <Select.Option value={2}>三级菜单</Select.Option>
              </Select>)}
          </Form.Item>
          <Form.Item label="菜单名称" {...FORM_ITEM_LAYOUT}>
            {getFieldDecorator('name', {
            initialValue: isEditMode ? initialValue.name : undefined,
            rules: [{ required: true }],
        })(<Input />)}
          </Form.Item>
          <Form.Item label={<div style={{ display: 'inline-block', cursor: 'pointer' }}>
                路由&nbsp;
                <Tooltip title="格式为 https:// 或者 http:// 时点击菜单项会打开新页面跳转到该地址">
                  <Icon type="question-circle"/>
                </Tooltip>
                &nbsp;
              </div>} {...FORM_ITEM_LAYOUT}>
            {getFieldDecorator('path', {
            initialValue: isEditMode ? initialValue.path : undefined,
            rules: [{ required: true }],
        })(<Input />)}
          </Form.Item>
          <Form.Item label={<div style={{ display: 'inline-block', cursor: 'pointer' }}>
                项目链接地址&nbsp;
                <Tooltip title="需要嵌入工程效率平台的地址">
                  <Icon type="question-circle"/>
                </Tooltip>
                &nbsp;
              </div>} {...FORM_ITEM_LAYOUT}>
            {getFieldDecorator('url', {
            initialValue: isEditMode ? initialValue.url : undefined,
        })(<Input />)}
          </Form.Item>
          <Form.Item label="埋点" {...FORM_ITEM_LAYOUT}>
            {getFieldDecorator('buried', {
            initialValue: isEditMode ? initialValue.buried : undefined,
        })(<Input />)}
          </Form.Item>
          <Form.Item label="统一工作台资源code" {...FORM_ITEM_LAYOUT}>
            {getFieldDecorator('resourceCode', {
            initialValue: isEditMode ? initialValue.resourceCode : undefined,
        })(<Input />)}
          </Form.Item>
        </Form>
      </Root>);
    }
}
export default Form.create()(AddMenuModal);
